import Dashboard from '@/components/pages/Dashboard/Dashboard_v2'
import Overview from '@/components/pages/Dashboard/Overview_v2'
import SurgeonSatisfaction from '@/components/pages/Dashboard/Breakdowns/SatisfactionSurgeon_v2'
import SatisfactionOutcomes from '@/components/pages/Dashboard/Breakdowns/SatisfactionOutcomes_v2'
import SatisfactionHospital from '@/components/pages/Dashboard/Breakdowns/SatisfactionHospital_v2'
import SpectacleIndependence from '@/components/pages/Dashboard/Breakdowns/SpectacleIndependence_v2'
import TargetRefraction from '@/components/pages/Dashboard/Breakdowns/TargetRefraction_v2'
import Dysphotopsia from '@/components/pages/Dashboard/Breakdowns/Dysphotopsia_v2'
// import AdditionalProcedures from '@/components/pages/Dashboard/Breakdowns/AdditionalProcedures'
import RegisteredPatients from '@/components/pages/Dashboard/Breakdowns/RegisteredPatients_v2'
import RegisteredUsers from '@/components/pages/Dashboard/Breakdowns/RegisteredUsers_v2'
import IolUsage from '@/components/pages/Dashboard/Breakdowns/IolUsage_v2'
import Catprom from '@/components/pages/Dashboard/Breakdowns/Catprom5_v2'
import Catquest from '@/components/pages/Dashboard/Breakdowns/Catquest9_v2'
import DoctorConfidence from '@/components/pages/Dashboard/Breakdowns/DoctorConfidence_v2'
import QualityOfService from '@/components/pages/Dashboard/Breakdowns/QualityOfService_v2'
import ClinicRecommendation from '@/components/pages/Dashboard/Breakdowns/ClinicRecommendation_v2'

export default {
  path: '/',
  redirect: '/dashboard',
  component: Dashboard,
  name: 'Dashboard',
  meta: {
    requiresAuth: true,
    userPermission: true
  },
  children: [
    {
      name: 'Overview',
      path: '/dashboard',
      component: Overview,
      meta: {
        breadcrumb: 'Overview',
        requiresAuth: true
      }
    },
    {
      name: 'Satisfaction with surgeon',
      path: '/dashboard/surgeon_satisfaction/:report_id',
      component: SurgeonSatisfaction,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Satisfaction with hospital',
      path: '/dashboard/hospital_satisfaction/:report_id',
      component: SatisfactionHospital,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Satisfaction with outcomes',
      path: '/dashboard/outcomes_satisfaction',
      component: SatisfactionOutcomes,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Spectacle independence',
      path: '/dashboard/spectacle_independence',
      component: SpectacleIndependence,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Expectations met',
      path: '/dashboard/target_refraction/:report_id',
      component: TargetRefraction,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Visual disturbances',
      path: '/dashboard/dysphotopsia',
      component: Dysphotopsia,
      meta: {requiresAuth: true},
      props: true
    },
    /* {
      name: 'Additional procedures',
      path: '/dashboard/additional_procedures',
      component: AdditionalProcedures,
      meta: {requiresAuth: true},
      props: true
    },*/
    {
      name: 'Registered patients',
      path: '/dashboard/registered_patients/:report_id',
      component: RegisteredPatients,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Registered users',
      path: '/dashboard/registered_users/:report_id',
      component: RegisteredUsers,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'IOL usage',
      path: '/dashboard/iol_usage/:report_id',
      component: IolUsage,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Cat-PROM5',
      path: '/dashboard/catprom/:report_id',
      component: Catprom,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Cat-PROM5 Pre-Op',
      path: '/dashboard/catprom/:report_id',
      component: Catprom,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Catquest-9SF',
      path: '/dashboard/catquest/:report_id',
      component: Catquest,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Catquest-9SF Pre-Op',
      path: '/dashboard/catquest/:report_id',
      component: Catquest,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Doctor confidence',
      path: '/dashboard/doctor_confidence/:report_id',
      component: DoctorConfidence,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Quality of service',
      path: '/dashboard/quality_of_service/:report_id',
      component: QualityOfService,
      meta: {requiresAuth: true},
      props: true
    },
    {
      name: 'Recommendation',
      path: '/dashboard/clinic_recommendation/:report_id',
      component: ClinicRecommendation,
      meta: {requiresAuth: true},
      props: true
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/dashboard.js